import { render, staticRenderFns } from "./oldNew.vue?vue&type=template&id=8d6ae376&"
import script from "./oldNew.vue?vue&type=script&lang=js&"
export * from "./oldNew.vue?vue&type=script&lang=js&"
import style0 from "./oldNew.vue?vue&type=style&index=0&id=8d6ae376&prod&lang=scss&"
import style1 from "./oldNew.vue?vue&type=style&index=1&id=8d6ae376&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports